var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-layout',{attrs:{"text-xs-center":"","align-center":"","justify-center":""}},[_c('v-flex',[_c('img',{attrs:{"src":require("@/assets/logo.png"),"alt":"Gritus"}})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }